import ImageService from '@/services/ImageService'
import GLTFService from '@/services/GLTFService'

import AppStore from 'src/store/app'
import { HOME, PATHS } from '@/config/app'
import Env from 'src/config/env'


import { clamp, map, DEG_TO_RAD, randomInRange, randomDist } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from 'src/helpers/EventEmitter'

import AnimationConfig from 'src/config/animation'
import BaseGroup from '@/components/stage/common/base_group'

import gsap from 'gsap'
import dat from 'dat.gui'

const THREE = require('three')
import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils.js'

// import vert from '@/components/stage/shaders/home/triangle.vert'
import frag from '@/components/stage/shaders/home/triangle.frag' 
import vert_before from '@/components/stage/shaders/home/triangle_before.vert'
import vert from '@/components/stage/shaders/home/triangle.vert'


const Events = {}
 

class Bubble extends BaseGroup {

  constructor(config) {

    super(config)

    this.Events = Events
    Object.assign(this, EventEmitter) 

    this.options = { } 

    this.tweenObj= {
      y: 10,
      rotationSpeed: 0.001,
      itemRotationSpeed: 0,
      blendAmt: 0,
      gradUv: new THREE.Vector2(0.5, 0.5)
    }

    this.setup()
    this.resize()

    this.render = false
    this.rotate = false
  }

  setup() {

    this.options = { 
      matCapAmt: 1, 
      startColor: 0x191b44,
      stopColor: 0x4046b0
    }  
 
    this.material = new THREE.MeshMatcapMaterial({  
      matcap: this.textures.blue_matcap,
      transparent: true,
      flatShading: true 
    }) 
    
    let res = new THREE.Vector2(window.innerWidth * Env.pixelRatio, window.innerHeight * Env.pixelRatio)
    this.material.userData.matCapAmt = { value: this.options.matCapAmt }
    this.material.userData.cameraZ = { value: 5. }  
    this.material.userData.blendAmt = { value: this.tweenObj.blendAmt }  
    this.material.userData.gradUv = { value: this.tweenObj.gradUv }  
    this.material.userData.resolution = { value: res } 


    this.material.onBeforeCompile = shader => {  
 
      shader.uniforms.matCapAmt = this.material.userData.matCapAmt 
      shader.uniforms.blendAmt = this.material.userData.blendAmt 
      shader.uniforms.gradUv = this.material.userData.gradUv 
      shader.uniforms.cameraZ = this.material.userData.cameraZ 
      shader.uniforms.startColor = this.material.userData.startColor 
      shader.uniforms.stopColor = this.material.userData.stopColor 
      shader.uniforms.resolution = this.material.userData.resolution  
 

      shader.vertexShader = vert_before + shader.vertexShader;

      shader.vertexShader = shader.vertexShader.replace(
        '#include <begin_vertex>',
        [ 
          '#include <begin_vertex>',  
          vert
        ].join( '\n' )
      )
 
      shader.fragmentShader = [
          'uniform float matCapAmt;', 
          'uniform float cameraZ;',
          'uniform float blendAmt;',
          'uniform vec2 gradUv;', 
          'uniform vec2 resolution;',  
          'varying vec3 vPos;',
         // 'varying vec4 vWorldPosition;',
          '',
        ].join( '\n' ) + shader.fragmentShader;
    
      shader.fragmentShader = shader.fragmentShader.replace(  '#include <diffuse_fragment>', '');
      shader.fragmentShader = shader.fragmentShader.replace( 
          '#include <common>', 
          [
            '#include <common>',
            'float circle(vec2 _st, float _radius){',
              'vec2 dist = _st;',
              'return 1.-smoothstep(_radius-(_radius*0.1), _radius+(_radius * 2.), dot(dist,dist)*4.);',
            '}'
          ].join( '\n' )
      ); 
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <fog_fragment>',
        [  
          'vec4 matCap = gl_FragColor;',     

          'vec2 res = vec2(gl_FragCoord.x / resolution.x , gl_FragCoord.y / resolution.y);',

          'float normalDepth = pow(1. - clamp(clamp(abs(vPos.z - cameraZ ), 0. , cameraZ) / cameraZ, 0., 1.), 0.5);',

          'float startOpacity = mix(10., 3., blendAmt);',  
          'float stopOpacity = mix(3., 10., blendAmt);', 
          // 'float gradBlend = 1. - pow(pcurve(res.x, startOpacity, stopOpacity), .07);', 
          'float gradMin = 0.05;', 
          'float gradMax = 1.;', 
          'float gradOpacity = 1. - circle(res - gradUv, 0.3) * 0.95;',
 
          'gl_FragColor = vec4(matCap.rgb,  gradOpacity * normalDepth * 0.95);', 
        ].join( '\n' )
      )
 
    }
   




    //this.material = new THREE.ShaderMaterial(material_options)
    this.cones = [] 

    let nx = 7
    let ny = 7
    let i = 0

    this.center = new THREE.Vector3(0.)
    var coneGeo = new THREE.ConeBufferGeometry(0.1, 0.6, 2 );
    var coneGeo2 = new THREE.ConeBufferGeometry(0.1, 0.6, 3 ); 

    var self = this
    var Cone = function(){

      this.mesh = new THREE.Object3D();
      this.mesh.name = "cone";
      
      var geo = Math.random() < 0.2 ? coneGeo : coneGeo2
      var tronc = new THREE.Mesh(coneGeo2, self.material);
      tronc.position.set(0,0,0);

      this.sxy = (0.1 + (Math.random())) 
      this.sz = 0.2 + (Math.random() * .5)
      this.rs = 0.2 +  Math.random() * 1.5// random scale 

      this.mesh.scale.x = this.mesh.sxy
      this.mesh.scale.y = this.mesh.sxy
      this.mesh.scale.z = this.mesh.sz

      tronc.rotation.x = 90 * DEG_TO_RAD 
      this.mesh.add(tronc); 

    }

  
    for (var x = 0; x < nx; x++){
      let lon = (x / nx) * (Math.PI ) 
      for (var y = 0; y < ny; y++){    
        
        i++
                                                       
        let lat =  Math.sin( y/ny-0.5 ) * (Math.PI * 2) 
        let cone = new Cone()
        this.cones.push(cone)
        let rx = lat + (Math.sin(Math.random()) * 0.5)
        let ry = lon + (Math.sin(Math.random()) * 0.5)
        cone.mesh.position.setFromSphericalCoords(7 + (Math.random() + 3) , ry, rx);
        cone.mesh.lookAt(this.center); 
        cone.px = cone.mesh.position.x
        cone.py = cone.mesh.position.y
        cone.pz = cone.mesh.position.z
        cone.rotationSpeed = (Math.sin(Math.random() + i) * 0.005) 
        cone.mesh.rotation.z += (cone.rotationSpeed * this.tweenObj.itemRotationSpeed) 
        cone.mesh.children[0].position.z = Math.sin(cone.mesh.rotation.z) * 0.5
        cone.mesh.lookAt(this.center); 

        this.add(cone.mesh) 
      } 
    }
 
  }

  addGUI() {}

  updateGUI () {}


  pointerMove(event){ }

  pointerStart(event){ }

  pointerEnd(event){ }

  setTrianglePositions(position){

    const home = AppStore.state.home 
    const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT )
    this.base_delay = AnimationConfig.home.section.duration * 0.8
    let duration = this.getDuration(this.base_delay)
    let ease = isHomeModeDefault ? `back.out(${4 * Math.random()})` : 'expo.out'

    for (let i = 0; i < this.cones.length; i++) {   
      let cone = this.cones[i] 
      let random_delay = (this.base_delay + Math.random() * 0.5)
      let delay = isHomeModeDefault ? this.getDuration(random_delay) : 0
      gsap.to(cone.mesh.position, duration, {
        y: cone.py * position, 
        x: cone.px * position, 
        z: cone.pz * position, 
        ease: ease, 
        delay: delay
      })

      gsap.to(cone.mesh.scale, duration, {
        y: cone.sxy * ( cone.rs * ((1/position) * 0.5) ), 
        x: cone.sxy * ( cone.rs * ((1/position) * 0.5) ), 
        z: cone.sz * ( cone.rs * ((1/position) * 0.5) ), 
        ease: ease, 
        delay: delay
      })
    }
  }



  // UPDATES -------------------------------------------------------------------


  tick(dt ) { 

    if(this.render){ 

      if(this.tweenObj.itemRotationSpeed > 0){
        for (let i = 0; i < this.cones.length; i++) {   
          let cone = this.cones[i] 
          cone.mesh.rotation.z += (cone.rotationSpeed * this.tweenObj.itemRotationSpeed) 
          cone.mesh.children[0].position.z = Math.sin(cone.mesh.rotation.z) * 0.5
        }
      }

      //if(this.tweenObj.rotationSpeed > 0){
        this.rotation.y -= this.tweenObj.rotationSpeed
      //}

      if( this.material ){
        // window.console.log(this.cameraGroup.camera.position.z)
        this.material.userData.cameraZ.value = this.cameraGroup.camera.position.z 
      }
    }

  }

  resize() {
    let ww = window.innerWidth
    let wh = window.innerHeight
  }

  destroy(){}
 
  enter(){ }

  leave(){ }

  startRotation(){ 
    gsap.to(this.tweenObj, this.getDuration(AnimationConfig.home.section.duration), { rotationSpeed: 0.0012, ease: 'Expo.easeInOut'  }) 
  }

  stopRotation(){ 
    gsap.to(this.tweenObj, 1, { rotationSpeed: 0.001  }) 
  }

  updateItemRotation(value = 0){
    gsap.killTweensOf(this.tweenObj, { itemRotationSpeed: true  }) 
    gsap.to(this.tweenObj, 1, { itemRotationSpeed: value, ease: 'Expo.easeInOut'   }) 
  }

  updateBlendAmt(value){
    gsap.killTweensOf(this.tweenObj, { blendAmt: true }) 
    gsap.to(this.tweenObj, { 
      duration: this.getDuration(AnimationConfig.home.section.duration),
      blendAmt: value, 
      ease: 'Expo.easeInOut',
      onUpdate: () => {
        this.material.userData.blendAmt.value = this.tweenObj.blendAmt 
      }
    }) 
  }

  updateGradPosition(x, y){
    gsap.killTweensOf(this.tweenObj, { gradUv : true }) 
    gsap.to(this.tweenObj.gradUv,  {
      duration: this.getDuration(AnimationConfig.home.section.duration), 
      x: Env.mobile ? 0.4 : x, 
      y: Env.mobile ? 0.2 : y, 
      ease: 'Expo.easeInOut',
      onUpdate: () => {
        this.material.userData.gradUv.value.x = this.tweenObj.gradUv.x 
        this.material.userData.gradUv.value.y = this.tweenObj.gradUv.y
      }
    }) 
  }

  getDuration(duration){ 
    let clamp = this.reduced_motion ? 0 : 1
    return ( duration * clamp )
  }



  // HANDLERS -------------------------------------------------------------------



  // STATES -------------------------------------------------------------------

  /* modal states */

  /*
    none
    menu
    video
  */

  /* page states */

  routeLoading(){ }

  routeHome(){
  }


  /* home states */

  welcome(val, prev){ 
    this.render = false 
    this.stopRotation()
    this.setTrianglePositions(1)
    this.updateItemRotation(0)
    this.updateGradPosition()
  }

  ratingFive(val, prev){
    this.setTrianglePositions(0.43)
    this.render = true 
    this.stopRotation()
    this.updateItemRotation(0)
    this.updateBlendAmt(0)
    this.updateGradPosition(0.8, 0.5)
  }

  ratingFour(val, prev){
    this.setTrianglePositions(0.35)
    this.render = true 
    this.stopRotation()
    this.updateItemRotation(0)
    this.updateBlendAmt(1)
    this.updateGradPosition(0.2, 0.5)
  }

  ratingThree(val, prev){
    this.setTrianglePositions(0.3 )  
    this.render = true 
    this.stopRotation()
    this.updateItemRotation(0)      
    this.updateBlendAmt(0)
    this.updateGradPosition(0.8, 0.5)
  }

  ratingTwo(val, prev){ 
    this.setTrianglePositions(0.27)
    this.render = true 
    this.stopRotation()
    this.updateItemRotation(1)
    this.updateBlendAmt(1)
    this.updateGradPosition(0.2, 0.5)
  }

  ratingOne(val, prev){ 
    this.setTrianglePositions(0.25)
    this.render = true 
    this.stopRotation()
    this.updateItemRotation(1)
    this.updateBlendAmt(0) 
    this.updateGradPosition(0.8, 0.5)
  }

  cta(val, prev){
    this.setTrianglePositions(0.27)
    this.render = true 
 
    this.startRotation()
    this.updateItemRotation(1)
    this.updateBlendAmt(1)
    this.updateGradPosition(0.3, 0.5)
  }

}


export default Bubble 